import {FirestoreDocSnapshotWithIdAndData} from '@coolcolduk/firebase-util';
import {mapFirestoreDocWithTimestamp} from '../_other/firestore';
import {ContactMessageDb} from './contactMessageDbSchema';
import {ContactMessage, contactMessageSchema} from './contactMessageSchema';

/**
 * Convert contact message db to contact message type
 * @param db ContactMessageDb
 * @returns ContactMessage
 */
export function mapContactMessageDbToType(db: FirestoreDocSnapshotWithIdAndData<ContactMessageDb>): ContactMessage {
  const data = mapFirestoreDocWithTimestamp(db);
  return contactMessageSchema.parse(data);
}
